export const isEmpty = (value: unknown) => {
    if (value === undefined || value === null) {
        return true;
    }
    if (Array.isArray(value) || typeof value === 'string') {
        return value.length === 0;
    }
    if (typeof value === 'object' && value) {
        return Object.keys(value).length === 0;
    }

    return false;
};
